<ng-container *ngIf="additionalNamesLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_ADDI'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="additionalNamesError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_ADDI'] }}</p>
	</div>
</ng-container>

<ng-container *ngIf="!additionalNamesLoading && !additionalNamesError">
	<div class="flex justify-between items-center mb-3 px-2">
		<!-- Left: Create New button -->
		<button pButton type="button" icon="pi pi-plus"
			label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
			class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

		<!-- Right: Global filter -->
		<span class="p-input-icon-left">
			<i class="pi pi-search"></i>
			<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
				placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}" class="p-inputtext-sm" />
		</span>
	</div>
	<div class="horizontal-scroll">
		<p-table #dt id="tab_addi_name" dataKey="RecID" [globalFilterFields]="globalFilterFields"
			[value]="additionalNames" *ngIf="additionalNames && additionalNames.length > 0; else noAdditionalNames"
			styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
			responsiveLayout="scroll" [paginator]="true" [totalRecords]="additionalNames.length"
			[rows]="getCurrentPageSize(0, additionalNames.length)" [rowsPerPageOptions]="setPaginator(additionalNames.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_ADDI'] || 'Additional Names' }}"
			[tableStyle]="{'min-width': '78rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'"
			(onPage)="onRowsPerPageChange($event,  0, additionalNames.length)">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === additionalNames.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="CustomerName">
						{{ translateServ.dictionary['STEP_BASIC_BUSS_NAME_TITLE'] || 'Business Name' }}
						<p-sortIcon field="CustomerName"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-additionalName>
				<tr>
					<td>{{ additionalName.RecID }}</td>
					<td>{{ additionalName.CustomerName }}</td>

					<!-- Status -->
					<td>
						<p-tag
							[value]="additionalName.IsActive === 1 ? (translateServ.dictionary['ACTIVE'] || 'Active') : (translateServ.dictionary['INACTIVE'] || 'Inactive')"
							[severity]="getAdditionalNameSeverity(additionalName.IsActive === 1)"
							(click)="toggleAdditionalNameStatus(additionalName, true)">
						</p-tag>
					</td>

					<!-- Approved -->
					<td>
						<p-tag
							[value]="additionalName.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
							[severity]="additionalName.IsApproved === 1 ? 'success' : 'warning'"
							(click)="toggleAdditionalNameStatus(additionalName, false)">
						</p-tag>
					</td>

					<!-- Description with tooltip -->
					<td>
						<span *ngIf="additionalName.Descr; else noDescr" [pTooltip]="additionalName.Descr"
							tooltipPosition="top">
							{{ additionalName.Descr.length > 20 ? (additionalName.Descr | slice:0:20) + '…' :
							additionalName.Descr }}
						</span>
						<ng-template #noDescr>
							<span class="text-gray-400">—</span>
						</ng-template>
					</td>

					<!-- Dates -->
					<td>
						{{ additionalName.DateEntered ? (additionalName.DateEntered | date:'mediumDate') : 'N/A' }}
					</td>
					<td>
						{{ additionalName.DateUpdated ? (additionalName.DateUpdated | date:'mediumDate') : 'N/A' }}
					</td>

					<!-- Actions -->
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editAdditionalName(additionalName)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(additionalName)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noAdditionalNames>
		<div class="text-center p-4">
			<i class="pi pi-tag text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_ADDI'] || 'No additional names found' }}</p>
		</div>
	</ng-template>
</ng-container>